var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "720", persistent: _vm.saving },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mb-4 mr-2",
                      attrs: {
                        color: "primary",
                        "data-test": "steffi-open-offline-contract",
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _vm._v(
                    "\n            Vertragsset wurde offline angenommen\n        "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Vertragsset wurde offline angenommen")]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _vm.error
                ? _c(
                    "v-alert",
                    { attrs: { type: "error", outlined: "", dense: "" } },
                    [_vm._v(_vm._s(_vm.error))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  label: "Apotheke suchen",
                  maxlength: "100",
                  hint: "Mindestens 2 Zeichen: Name, Kundennummer, Postleitzahl oder Ort",
                  "persistent-hint": "",
                  disabled: _vm.loading || _vm.saving,
                  "data-test": "steffi-contract-search",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.findPharmacies.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    outlined: "",
                    disabled:
                      _vm.search.trim().length < 2 || _vm.loading || _vm.saving,
                    loading: _vm.loading,
                    "data-test": "steffi-contract-search-submit",
                  },
                  on: { click: _vm.findPharmacies },
                },
                [_vm._v("Suchen")]
              ),
              _vm._v(" "),
              _vm.items
                ? [
                    !_vm.items.length && !_vm.loading
                      ? _c("p", { staticClass: "mt-4" }, [
                          _vm._v("Keine Apotheken gefunden."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { disabled: _vm.loading || _vm.saving },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      },
                      _vm._l(_vm.items, function (item) {
                        return _c("v-radio", {
                          key: item.pharmacy_id,
                          attrs: { value: item },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("strong", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.customer_id || item.pharmacy_id
                                          ) +
                                            " · " +
                                            _vm._s(item.zip) +
                                            " " +
                                            _vm._s(item.city)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.selected
                ? [
                    _c("v-select", {
                      attrs: {
                        items: _vm.planItems,
                        dense: "",
                        outlined: "",
                        label: "Paket",
                        "data-test": "steffi-contract-plan",
                      },
                      model: {
                        value: _vm.form.plan_code,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "plan_code", $$v)
                        },
                        expression: "form.plan_code",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        dense: "",
                        outlined: "",
                        type: "date",
                        label: "Vertrags-/Annahmedatum",
                        "data-test": "steffi-contract-date",
                      },
                      model: {
                        value: _vm.form.accepted_at,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "accepted_at", $$v)
                        },
                        expression: "form.accepted_at",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        dense: "",
                        label: "Mit kostenloser 14-tägiger Testphase starten",
                        "data-test": "steffi-contract-trial",
                      },
                      model: {
                        value: _vm.form.trial_requested,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "trial_requested", $$v)
                        },
                        expression: "form.trial_requested",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        dense: "",
                        label:
                          "Das Vertragsset einschließlich Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung wurde angenommen.",
                        "data-test": "steffi-contract-accepted",
                      },
                      model: {
                        value: _vm.form.accepted_contract_terms,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "accepted_contract_terms", $$v)
                        },
                        expression: "form.accepted_contract_terms",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-textarea", {
                      attrs: {
                        dense: "",
                        outlined: "",
                        "auto-grow": "",
                        rows: "2",
                        label: "Interne Notiz",
                        "data-test": "steffi-contract-note",
                      },
                      model: {
                        value: _vm.form.internal_note,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "internal_note", $$v)
                        },
                        expression: "form.internal_note",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Schließen")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.canSave,
                    loading: _vm.saving,
                    "data-test": "steffi-contract-save",
                  },
                  on: { click: _vm.save },
                },
                [_vm._v("Steffi hinzufügen")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }